import React, { useRef, useEffect} from 'react';
import { StyledHeroText } from './StyledHeroText';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const HeroText = ({ textBelow, title, subtitle, paragraph, image, align, isLanding, greyParagraph, extraParagraph,alignBg, isImage, isWebinar, date, place }) => {

  const imageRef = useRef(null)
  useEffect(() => {
    
    if(image)
      gsap.to(imageRef.current, {
        scale: '1.1',
        ease: "none",
        scrollTrigger: {
          trigger: imageRef.current,
          start: "top bottom", 
          end: "+=100%",
          scrub: 1
        }
      });
  }, []);

  return (
    <React.Fragment>
      {
       
        <StyledHeroText 
          align={align} 
          greyParagraph={greyParagraph}
          textBelow={textBelow}
        >
          <div className="hero-text--wrap">
            <h4 
              className={`${!textBelow ? 'padding--bottom' : ''} md--title`}
              dangerouslySetInnerHTML={{ __html: title }}></h4>
            {
              !textBelow &&
              <p className="preset-9">{paragraph}</p>
            }
            {
              isWebinar && 
              <div className="details-wrapper">
                {
                  date &&
                  <div className="detail-col">
                    <img src="/calendar-date.svg" />
                    <p className="preset-12">{date}</p>
                  </div>
                }
                {
                  place !== "" && 
                  <div className="detail-col">
                    <img src="/location.svg" />
                    <p className="preset-12">{place}</p>
                  </div>
                }
                <div className="detail-col">
                  <p className="preset-12 primary-green">
                  <a href="http://www.google.com/calendar/render?action=TEMPLATE&text=Invrsion+and+Sketchfab+-+Webinar&dates=20220126T1700000Z/20220126T1745000Z&details=Thank+you+for+registering+to+our+webinar!<br/>This+conversation+with+Invrsion+and+Sketchfab+will+bring+you+the+Full+View+of+the+latest+research,+innovation,+and+best+practices+to+drive+higher+revenues+through+3D+render+for+your+eCommerce+business+and+the+future+of+3D+solutions+for+the+next+iteration+of+eCommerce.<br/>We+look+forward+to+your+participation+in+this+event.<br/><br/>12:00+PM+-+12:15+PM+EST+<br/>+<b>About+Invrsion+and+3D+Commerce</b><br/><br/>12:15+PM+-+12:35+PM+EST+<br/>+<b>About+Sketchfab</b><br/><br/>12:35+PM+-+12:45+PM+EST+<br/>+<b>Q%26A</b>&location=Zoom"
                        target="_blank" rel="nofollow">
                          Add to calendar
                      </a>
                      <span className="calendar-add"></span>
                  </p>
                </div>
              </div>
            }
          </div>

          
          
          {
            (image && !isImage) &&
            <div className={`${!textBelow ? 'zero--bottom' : ''} hero-text--image`} ref={imageRef} style={{backgroundImage: `url(${image})`, backgroundPosition:  `${alignBg}`}}></div>
          }
          
          {
            isImage &&
            <div className={`${!textBelow ? 'zero--bottom' : ''} hero-text--image full--image`} ref={imageRef} >
              <img src={`${image}`} />
            </div>
          }
          {
            textBelow &&
            <div className={isLanding ? "hero-text--wrap hero-text--below hero-text--below-landing" : "hero-text--wrap hero-text--below"}>
              {
                subtitle &&<h5 className="big--title">{subtitle}</h5>
              }
              {
                extraParagraph && <h6 className="md--title">{extraParagraph}</h6>
              }
              <p className="preset-9" dangerouslySetInnerHTML={{ __html: paragraph }}></p>
            </div>
          }
          
          
        </StyledHeroText>
          
          
      }
    </React.Fragment>
  );
};

HeroText.defaultProps = {
  alignBg: "50% 50%"
};
export default HeroText;
